<template>
  <div class="navbar">
    <div class="left">
      <i class="toggle-icon" :class="sidebarOpened ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="toggleSidebar"></i>
      <breadcrumb />
    </div>
    <div class="right">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-info">
          <el-avatar :size="30" :src="avatar || undefined" icon="el-icon-user-solid"></el-avatar>
          <span class="name">{{ realName || userName }}</span>
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人中心</el-dropdown-item>
          <el-dropdown-item command="password">修改密码</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" :visible.sync="pwdVisible" width="420px" append-to-body>
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="80px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Breadcrumb from './Breadcrumb.vue'
import { changePassword } from '@/api/auth'

export default {
  name: 'Navbar',
  components: { Breadcrumb },
  data() {
    return {
      pwdVisible: false,
      pwdForm: { oldPassword: '', newPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '密码至少6位', trigger: 'blur' }]
      }
    }
  },
  computed: { ...mapGetters(['sidebarOpened', 'userName', 'realName', 'avatar']) },
  methods: {
    ...mapActions(['toggleSidebar']),
    handleCommand(cmd) {
      if (cmd === 'logout') this.logout()
      else if (cmd === 'password') this.pwdVisible = true
      else if (cmd === 'profile') this.$message.info('个人中心功能待开发')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push('/login')
    },
    submitPwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return
        await changePassword(this.pwdForm)
        this.$message.success('密码修改成功，请重新登录')
        this.pwdVisible = false
        await this.$store.dispatch('user/logout')
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 16px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.left { display: flex; align-items: center; }
.toggle-icon { font-size: 20px; cursor: pointer; margin-right: 16px; }
.user-info { display: flex; align-items: center; cursor: pointer; outline: none; }
.user-info .name { margin: 0 6px 0 8px; font-size: 14px; }
</style>
